let addonsEl = document.querySelector('#product-addons');

// New product option selected (i.e., silver/black, unlimited/limited tunes)
document.querySelectorAll('.addon-option-selector').forEach((selectElement) => {
  selectElement.addEventListener('change', function () {
    let option = this.options[this.selectedIndex];

    let product_id = option.getAttribute('data-product-id');
    let productEl = addonsEl.querySelector(`.product-addon[data-product-id="${product_id}"]`);
    let input = productEl.querySelector('input')

    let image_id = option.getAttribute('data-image-id');
    let price = option.getAttribute('data-price');
    let compare_at_price = option.getAttribute('data-compare-at-price');
    let sku = option.getAttribute('data-sku');

    let price_formatted = '$' + (price / 100).toFixed(2) + ' CAD';
    let compare_at_price_formatted = '$' + (compare_at_price / 100).toFixed(2) + ' CAD';

    // Removes disabled from input once a valid option selected
    input.removeAttribute('disabled', '');
    input.checked = true;

    // Update current addon's price from this selected option
    let priceEl = document.querySelector(`#product-addon-price-${product_id}`);
    if (priceEl) {
      priceEl.textContent = price_formatted;
    }

    // Update addon's SKU from selected option
    if (sku) {
      let skuEl = productEl.querySelector('.product-meta__sku');
      if (skuEl) {
        skuEl.innerText = 'Part No: ' + sku;
      }
    }

    console.log('Selected option:', option);
    if (option.classList.contains('placeholder')) {
      console.log('Placeholder is selected');
    } else {
      console.log(`Selected option: ${option.textContent}`);
    }

    // Update compare-at-price
    let compareAtPriceEl = document.querySelector(`#product-addon-compare-at-price-${product_id}`);
    if (compareAtPriceEl) {
      if (parseFloat(compare_at_price) > parseFloat(price)) {
        compareAtPriceEl.textContent = compare_at_price_formatted;
      } else {
        compareAtPriceEl.textContent = '';
      }
    }

    // Update image for addon product
    if (typeof update_image_for_addon_product === 'function') {
      update_image_for_addon_product(product_id, image_id);
    }

    // Update total price
    if (typeof show_total_price === 'function') {
      show_total_price();
    }
  });
});

$(".product-addon-checkbox").change(function() {
    show_total_price();
});


document.addEventListener('variant:added', function(event) {
  var variant = event.detail.variant; // Get the variant that was added
  add_addons_to_cart();
});


async function add_addons_to_cart() {
    // Check for any add-on products and add them now
    let items = [];

    $('input[type=checkbox].product-addon-checkbox:checked').each(function() {
      let product_id = $(this).data("product-id");
      let selected_option = $(`#addon-option-selector-${product_id}`).find(":selected");

      let item = {
        id: selected_option.data("variant-id"),
        quantity: $(this).data("quantity")
      };

      items.push(item);
    });

    if (items.length > 0) {
      $.ajax({
        method: 'POST',
        url: `${window.themeVariables.routes.cartUrl}/add.js`,
        dataType: 'json',
        data: {items}
      }).then(async function(response) {
        let cartContent = await fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
            let res_cart_content = await response2.json();
            return res_cart_content;
        });

        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: cartContent
          }
        }));

        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartContent
          }
        }));

      }).catch(function(error) {
        var errorMessage = error.responseJSON['description'];
        console.log(errorMessage);
      });
    }
};


function update_image_for_addon_product(product_id, image_id) {
  let images = $('.images-for-' + product_id);

  if (image_id == '') {
    return;
  }

  let has_variant_images = true;
  if ($('#addon-option-selector-' + product_id).css('display') == 'none') {
    has_variant_images = false;
  }

  // If there's only 1 image or this product doesn't have unique images for each variant, then we don't need to change the image
  if (images.length == 1 || !has_variant_images) {
    return;
  }

  // Only show image for selected variant
  images.each(function() {
    let image = $(this);
    image.hide();

    if (image.data('image-id') == image_id) {
      image.show();
    }
  });

}

document.addEventListener('variant:changed', function(event) {
  show_total_price();
});

document.addEventListener('quantity_selector:changed', function(event) {
  show_total_price();
});

function show_total_price() {
  // Get main product info
  let product_price = $('.product-meta__price-list-container span.price--large').text();
  product_price = product_price.replace(/[^0-9.]/gi, '');

  let quantity_selector = $('quantity-selector.quantity-selector')[0];
  let quantity_input = $(quantity_selector).find('.quantity-selector__input');
  let product_qty = parseInt($(quantity_input).val());

  if (isNaN(product_qty)) {
    $('#total_price_with_addons').text('');
    return;
  }

  // Get addon prices
  let addons = [];

  $('input[type=checkbox].product-addon-checkbox:checked').each(function() {
    // console.log('this parent', $(this).parent())
    $(this).parent().addClass('checked-box');
    let product_id = $(this).data("product-id");
    let selected_option = $(`#addon-option-selector-${product_id}`).find(":selected");
    let item = {
      id: selected_option.data("variant-id"),
      quantity: parseInt($(this).data("quantity")),
      price_each: parseFloat(selected_option.data("price")) / 100
    };
    addons.push(item);
  });

  $('input[type=checkbox].product-addon-checkbox:not(:checked)').each(function() {
    $(this).parent().removeClass('checked-box');
  });


  // No addons selected, and only 1 of main product selected
  if (addons.length <= 0 && product_qty <= 1) {
    $('#total_price_with_addons span').html('');
    $('#total_price_container').removeClass('total_price_selected');
    return;
  }

  $('#total_price_container').addClass('total_price_selected');


  let total_price = 0;
  total_price += parseFloat(product_price) * product_qty;

  addons.forEach(function(product_addon) {
  	total_price += product_addon.price_each * product_addon.quantity;
  });


  let price_formatted = '$' + total_price.toFixed(2) + ' CAD';
  $('#total_price_with_addons span').text(price_formatted);
}


$('.addon-option-selector').each(function() {
  $(this).trigger("change");
});


// Replace retail prices with wholesale ones
function set_wholesale_prices() {
  if (wholesale_tier == 'none') { return; }


  $('.product-addon').each(function() {
    let wholesale_data = $(this).attr('data-wholesale');
    let product_id = $(this).data('product-id');
    let wholesale_tiers = wholesale_data.split(',');
    let first_variant = true;

    wholesale_tiers.forEach(function(tier_data) {
      if (tier_data.split('--')[0] == `${wholesale_tier}-wholesale`) {
        wholesale_data = tier_data.split('--')[1];

        wholesale_data.split('^').forEach(function(variant_data) {
          let variant_id = variant_data.split('-')[0];
          let variant_price = variant_data.split('-')[1];
          let variant_element = $(`.addon-variant-option[data-variant-id="${variant_id}"]`);

          // Set the data to the wholesale prices
          variant_element.attr('data-compare-at-price', variant_element.attr('data-price'));
          variant_element.attr('data-price', variant_price);
        });
      }
    });
  });

  // Now trigger the change() event on each addon so the prices update to reflect wholesale
  $('.addon-option-selector').each(function() {
    $(this).trigger('change');
  });
}
set_wholesale_prices();